import React from "react";
import { TextField } from "@mui/material";
import { trakrefBlue, inputGrey, red, Grey3 } from "../../color_utils";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PropTypes from "prop-types";
import { trakrefFontFamily, trakrefFontFamilySemiBold } from "../../utils";

const defaultStlyes = {
    "& label.Mui-focused": {
        color: trakrefBlue,
    },
    "& .MuiOutlinedInput-root": {
        "&.Mui-focused fieldset": {
            borderColor: trakrefBlue,
        },
    },
    "& .MuiFilledInput-root": {
        backgroundColor: inputGrey,
        "&.Mui-focused fieldset": {
            borderColor: trakrefBlue,
        },
    },
    "& .MuiFormLabel-root": { fontFamily: trakrefFontFamily },
    "& .MuiFormLabel-root.MuiInputLabel-shrink": {
        textTransform: "uppercase",
        fontFamily: trakrefFontFamilySemiBold
    },
    "&  .MuiFormLabel-root.MuiInputLabel-root.Mui-error": {
        color: "#D51A1A !important",
        fontFamily: trakrefFontFamilySemiBold
    },
    "& .MuiInputBase-root.MuiInput-underline.Mui-error:after": {
        borderBottom: "2px solid #D51A1A !important",
    },
    "& .MuiFilledInput-root:after": { borderBottomColor: trakrefBlue },
};

const InputNumber = ({
    id,
    required,
    placeholder,
    label,
    value,
    onChange,
    onKeyDown,
    onFocus,
    onBlur,
    error,
    fullWidth,
    variant,
    helperText,
    multiLine,
    disabled,
    rows,
    maxCharacterLength,
    sx,
    minimumNumberValue,
    maximumNumberValue,
    hideStepper,
    allowDecimal,
}) => {

    const handleOnChange = (e) => {
        const { value } = e.target;

        const pattern = allowDecimal ? /^[0-9]*\.?[0-9]*$/ : /^[0-9]+$/;
        const isValid = pattern.test(value);
        if (!isValid && value !== '') {
            return;
        }

        onChange(e);
    }

    return (
        <TextField
            id={id}
            required={required}
            disabled={disabled}
            InputProps={{
                notched: !!value || value === 0,
                inputProps: {
                    maxLength: maxCharacterLength,
                    min: minimumNumberValue,
                    max: maximumNumberValue,
                    sx: {
                        "&::placeholder": {
                            color: Grey3,
                            opacity: 1,
                            fontSize: '16px',
                        },
                        fontFamily: trakrefFontFamily
                    }
                },
                endAdornment: error && <ErrorOutlineIcon sx={{ color: red }} />,
            }}
            InputLabelProps={{ shrink: !!value || value === 0 || placeholder }}
            label={label}
            placeholder={placeholder}
            value={value}
            defaultValue={value}
            onChange={handleOnChange}
            onKeyDown={onKeyDown}
            onFocus={onFocus}
            onBlur={onBlur}
            error={error}
            rows={rows}
            fullWidth={fullWidth}
            variant={variant}
            helperText={error ? helperText : ""}
            multiline={multiLine}
            sx={{ ...defaultStlyes, ...sx }}
            type={hideStepper ? "text" : "number"}
        />
    )
};

InputNumber.propTypes = {
    required: PropTypes.bool,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    error: PropTypes.bool,
    fullWidth: PropTypes.bool,
    variant: PropTypes.string,
    helperText: PropTypes.string,
    multiLine: PropTypes.bool,
    numberInput: PropTypes.string,
    disabled: PropTypes.bool,
    maxCharacterLength: PropTypes.number,
    id: PropTypes.string,
    sx: PropTypes.object,
    minimumNumberValue: PropTypes.number,
    maximumNumberValue: PropTypes.number,
    hideStepper: PropTypes.bool,
    allowDecimal: PropTypes.bool
};

InputNumber.defaultProps = {
    placeholder: "",
    required: false,
    disabled: false,
    error: false,
    fullWidth: false,
    variant: "outlined",
    helperText: "This field is required",
    multiLine: false,
    numberInput: "",
    onFocus: () => { },
    onBlur: () => { },
    onKeyDown: () => { },
    maxCharacterLength: 50000,
    id: "",
    sx: {},
    minimumNumberValue: 0,
    maximumNumberValue: 10000000000,
    hideStepper: false,
    allowDecimal: false
};

export default InputNumber;
